var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import getFetchWrapper from 'syf-api/api/getFetchWrapper';
import { marketingPreferencesUrl } from '../config';
var mutationFnFactory = function (config, keyProps, headers) {
    if (headers === void 0) { headers = {}; }
    var fetchWrapper = getFetchWrapper(config);
    return function (payload) {
        return fetchWrapper(marketingPreferencesUrl, {
            method: 'PATCH',
            body: JSON.stringify(__assign({ 'cipher.accountId': keyProps.accountId, accountIdType: keyProps.accountIdType }, payload)),
            headers: __assign({}, headers)
        });
    };
};
export default mutationFnFactory;
